<!-- ----------------------------------------------------------------------- -->
<!--                               Form Start                                -->
<!-- ----------------------------------------------------------------------- -->

<div class="row">
    <div class="form col-8 col-md-7 col-lg-6 mx-auto mt-5">
        <div class="form-header row">
            <div class="form-header__title col-12 mx-auto text-center">
                <div class="form-header-title__back">
                    <a class="cursor-pointer" (click)="redirectBack();"  role="button" >
                        <i class="fas fa-chevron-left"></i>
    
                        <span class="sr-only">Previous</span>
                      </a>
                </div>
                <h2 class="form-header-title__text">Select organization</h2>
            </div>
        </div>
    
        <!-- <div class="form-body row">
         
            <input type="Search" class="col-12 mx-auto form-body__input" maxlength="16" placeholder="Search Here" [(ngModel)]="organizationsData.keyword" (keydown.enter)="searchOrganization();false">
            <button type="submit" class="form-body__searchbtn" (click)="searchOrganization()"><i class="fas fa-search mr-3"></i>Search</button>
      
        </div> -->
    <!-- infinite scroll div -->
    
   <!-- infinity scroll div end -->
        <div class="row search-results"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()">
            <ul class="organizationlist col-12" >
                <li class="p-0 col-12 border-bottom-list" *ngFor="let organization of organizations">
                    <a [routerLink] = "['/auth/select-organization',organization.id]" role="button"  class="orgianzationlist-item col-12 row">
                    <figure class="col-4 col-md-2 organization-item-photo"><img src="{{organization.logo_url}}" class="img-fluid"  default="web-assets/images/group-3.png"></figure>
                    <div class="col-6 col-md-8 organization-item-name">{{organization.name}} </div>
                    <div class="col-2 col-md-2 organization-item-visit">
                            <i class="fas fa-chevron-right"></i>
                            <span class="sr-only">Previous</span>
                    </div>
                </a>
                </li>
               
            </ul>
    
    <!-- ----------------------------------------------------------------------- -->
    <!--                          Not Found Any Result                           -->
    <!-- ----------------------------------------------------------------------- -->
    
            <div class="not-found col-12 " *ngIf="!formIsLoading && organizations?.length === 0">
                <figure class="not-found__img col-12 text-center"><img class="img-fluid" src="web-assets/images/group-3.svg"></figure>
                <h2 class="not-found__title col-12 text-center">No results</h2>
                <p class="not-found__body col-12 text-center">Please check your keywords correctly and search again </p>
            </div>
            <div class="col-12" *ngIf="isShowSelectBtn">
                <div class="form-body__submit ">
                    <a  class="form-body__sumbit-btn" (click)="RedirectToMinMax()">NEXT</a>
                </div>
            </div>
        </div>
        <div class="row pb-5">
            <div class="col-md-12 p-5">
             <ngx-spinner
             bdOpacity = 0.9
             bdColor = ""
             size = "default"
             color = "#4aa03b"
             type = "ball-pulse-sync"
             [fullScreen] = "false"
             >
             </ngx-spinner>
           </div>
         </div>
    </div>
    </div>